import { render, staticRenderFns } from "./AddUsersBuilder.vue?vue&type=template&id=5a59e834&scoped=true"
import script from "./AddUsersBuilder.vue?vue&type=script&lang=js"
export * from "./AddUsersBuilder.vue?vue&type=script&lang=js"
import style0 from "./AddUsersBuilder.vue?vue&type=style&index=0&id=5a59e834&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a59e834",
  null
  
)

export default component.exports